import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcWireless = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M9.417 16.512a4.756 4.756 0 0 1 5.167 0c.463.3.459.945.068 1.335l-1.944 1.945a1 1 0 0 1-1.415 0L9.35 17.847c-.39-.39-.395-1.035.068-1.335Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M17.48 15.019c-.39.39-1.02.383-1.463.054a6.755 6.755 0 0 0-8.033 0c-.444.33-1.073.336-1.464-.054l-1.06-1.06c-.39-.391-.393-1.029.033-1.38a10.253 10.253 0 0 1 13.015 0c.426.351.424.989.033 1.38l-1.06 1.06Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M21.369 11.13c-.39.39-1.022.386-1.442.028-4.561-3.879-11.293-3.879-15.854 0-.42.358-1.052.362-1.442-.028L1.57 10.07c-.39-.391-.392-1.028.022-1.393 5.938-5.237 14.878-5.237 20.815 0 .415.365.413 1.002.023 1.392l-1.061 1.06Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
})), "IcWireless");

export { IcWireless };
//# sourceMappingURL=ic-wireless.js.map
